import React from "react";
import {Select} from "antd";
import * as PropTypes from "prop-types";

export const ProjectSelector = props => <React.Fragment>
  {props.projects && <div className='project-selector'>
    <Select
      showSearch
      defaultValue={null}
      onSelect={props.onSelect}
      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
      <Select.Option value={null}>All Projects</Select.Option>
      {props.projects.map((item, id) => <Select.Option key={id} value={item.id}>{item.name}</Select.Option>)}
    </Select>
  </div>}
</React.Fragment>;

ProjectSelector.propTypes = {
  projects: PropTypes.any,
  onSelect: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/components/Reports/ProjectSelector.js